module.exports = __webpack_public_path__ + "img/start-area.6c1684b0.jpg";